import React, { useState } from "react";
import { setAlert } from "action";
import { Row, Col, Button } from "reactstrap";
import ReactHtmlParser from "react-html-parser";
import { useDispatch } from "react-redux";
// import { loadStripe } from "@stripe/stripe-js";
import API from "../../../api"; // Add your API import path
import { platform } from "process";
import StarIcon from "../../../assets/images/star-03.png"

export default function StripeCards({ plan, isGold, makePayment }) {

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false)

  const cardDivClasses = `payCardInr payCardInr-h100 skyblue ${
    isGold === 1 ? "gold" : "silver-card__price"
  }`;

  const showDiscount = plan.discount > 0;

  const proceedToCheckout = async () => {
    try {
      setLoading(true)
      const response = await API({
        method: "POST",
        url: "/createCheckoutSession",
        data: {
          id: plan.id,
          platform : "la_pte",
        },
      });

      // if (response.data && response.data.checkout_url) {
      //   // Redirect directly to Stripe's hosted checkout page
      //   window.location.href = response.data.checkout_url;
      //   setLoading(false)
      // }

      const checkoutUrl = response?.data?.checkout_url;
      if (!checkoutUrl) {
        dispatch(setAlert({ flag: true, type: 2, message: "Unable to start checkout." }));
        return;
      }
      window.location.href = checkoutUrl;
    } catch (error) {
      dispatch(
      setAlert({ flag: true, type: 2, message: "Something went wrong." })
      );
      console.error("Checkout error:", error);
    }finally {
    setLoading(false);
     }
  };

  return (
    <>
    
      <Row className="main-container new-content mb-3 flex-column d-flex">
        <Col className="payCard payCard-new">
          <div className={cardDivClasses}>
            { isGold ? <span className="plan-badge gold"><img src={StarIcon} alt="Check icon" className="gold-check" /> Gold</span> : <span className="plan-badge silver">Silver</span>}
            <span className="planDuration">
              {plan.title} -{" "}
              <span className="payCardInr-duration">
                {plan.duration} MONTH{plan.duration > 1 ? "S" : ""}
              </span>
            </span>

            <span className="planRange">
              {ReactHtmlParser(plan.currency)} {plan.stripe_price || plan.price}
              <br />

              {showDiscount && (
                <span className="fs-4">
                  &nbsp;
                  <small>
                    <s>{plan.base_price}</s>
                  </small>
                  &nbsp;
                  {plan.discount + "% off"}
                </span>
              )}
            </span>
          </div>
        </Col>
        
        {plan.duration > 1 && <Col className="package-content d-flex mt-2 p-0">
          <ul style={{ alignSelf: "center", color: "red" }}>
            <li>You can cancel this subscription anytime.</li>
            <li>Price inclusive of all taxes *</li>
          </ul>
        </Col>}
        
      </Row>

      <Row className="payment-card-form">
        <Col>
          <button 
            className="process-payment-btn w-100" 
            onClick={proceedToCheckout}
            disabled={loading}
          >
           {loading ? "Processing..." : "Proceed to Checkout"}
          </button>
          <p className="form-text mt-2 text-center">
            You will be redirected to Stripe's secure checkout page
          </p>
        </Col>
      </Row>
    </>
  );
}